<template>
  <div>
    Game: {{ this.game.displayName }}
    <button @click="downloadCSV()">Download CSV</button>
    <pre v-if="csv">{{ this.csv }}</pre>
    <a v-show="false" ref="linker"></a>
  </div>
</template>

<script>
import * as sAPI from '../api/strapi.js'
export default {
  mounted () {
    this.init()
  },
  data () {
    return {
      csv: false,
      stats: false,
      game: false,
      players: false
    }
  },
  computed: {
    gameID () {
      return this.$route.params.gameID
    }
  },
  methods: {
    async calcStats () {
      if (this.game && this.players) {
        let stats = this.game.cells.reduce((ac, item) => {
          if (item.uid !== 'map') {
            ac.ppl[item.uid] = ac.ppl[item.uid] || { upgrade: 0, cell: 0, total: 0 }
            ac.ppl[item.uid].upgrade += Number(item.lvl)
            ac.ppl[item.uid].cell += 1
            ac.ppl[item.uid].total += 1 + Number(item.lvl)
          }
          return ac
        }, {
          ppl: {}
        })
        let bucket = []
        for (var kn in stats.ppl) {
          bucket.push({
            // userID: kn,
            ...this.players.find(p => p.userID === kn),
            ...stats.ppl[kn]
          })
        }
        this.stats = bucket
        console.log(bucket)
      }
    },
    async downloadCSV () {
      if (!this.stats) {
        return
      }
      let { Parser } = await import('json2csv')
      const fields = ['userID', 'displayName', 'color', 'upgrade', 'cell', 'total'];
      const opts = { fields };

      try {
        const parser = new Parser(opts);
        const csv = parser.parse(this.stats);
        console.log(csv);
        this.csv = csv;
        this.$refs['linker'].href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }))
        this.$refs['linker'].download = `Game Stats for ${this.game.displayName}, RoomID is ${this.gameID}`
        this.$refs['linker'].click()
      } catch (err) {
        console.error(err);
      }
    },
    async init () {
      this.IO = await sAPI.getIO()
      this.IO.on('connect', () => {
        this.IO.emit('join-game', { gameID: this.gameID, token: sAPI.LS.JWT, level: sAPI.Game.startLevel }, (data) => {
          if (this.leftGame) {
            return
          }
          this.game = data.game
          // this.processCache()
          // this.$forceUpdate()
          this.calcStats()
        })

        this.IO.on('player-patch', ({
          gameID,
          userID,
          player
        }) => {
          if (this.leftGame) {
            return
          }
          if (this.gameID === gameID) {
            let idx = this.players.findIndex(p => p.userID === player.userID)
            this.players[idx] = player
            this.players = this.players.slice()
            this.$forceUpdate()
          }
        })

        this.IO.on('players', ({ players }) => {
          if (this.leftGame) {
            return
          }
          this.players = players
          this.calcStats()
          // this.tryLocateMySelf()
        })

        // this.IO.on('mapview-delta', ({ gameID, notify }) => {
        //   if (this.leftGame) {
        //     return
        //   }
        //   // console.log(gameID, notify)
        //   if (this.game._id === gameID) {
        //     let newCells = jsondiffpatch.patch(this.game.cells, notify.cellPatch)
        //     if (hashObject(newCells) === notify.mapDoneHash) {
        //       this.game.cells = newCells
        //       this.loading = false
        //       this.ready = true
        //       this.$forceUpdate()
        //     }
        //   }
        // })
      })
    }
  }
}
</script>

<style>

</style>